<template>
    <div class="m-m">
        <h1>LUMI-O Credentials Management Service</h1>
        <p>The page you were looking for does not exist.</p>
        <a href="/">Return home</a>
    </div>
</template>

<script>
export default {
    name: "NotFound",
}
</script>